var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useFormGroups, useTranslate } from 'react-admin';
import { useFormContext, useFormState } from 'react-hook-form';
import { Button } from '@mui/material';
import { useWizardFormContext } from './useWizardFormContext';
export var NextButton = function (_a) {
    var disabled = _a.disabled, rest = __rest(_a, ["disabled"]);
    var translate = useTranslate();
    var trigger = useFormContext().trigger;
    var isValidating = useFormState().isValidating;
    var _b = useWizardFormContext(), currentStep = _b.currentStep, hasNextStep = _b.hasNextStep, goToNextStep = _b.goToNextStep;
    if (!goToNextStep) {
        throw new Error('The NextButton component cannot be used outside a WizardFormContext');
    }
    var formGroups = useFormGroups();
    var label = translate('ra-form-layout.action.next');
    var buttonRef = React.useRef(null);
    var handleClick = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var isGroupValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    // Prevent double submission
                    if (buttonRef.current) {
                        buttonRef.current.disabled = true;
                    }
                    return [4 /*yield*/, trigger(formGroups === null || formGroups === void 0 ? void 0 : formGroups.getGroupFields("step-".concat(currentStep)))];
                case 1:
                    isGroupValid = _a.sent();
                    if (isGroupValid) {
                        return [2 /*return*/, goToNextStep()];
                    }
                    if (buttonRef.current) {
                        buttonRef.current.disabled = false;
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [currentStep, formGroups, goToNextStep, trigger]);
    React.useEffect(function () {
        // Reset the button state when the step changes
        if (buttonRef.current) {
            buttonRef.current.disabled = false;
        }
    }, [currentStep]);
    if (!hasNextStep)
        return null;
    return (_jsx(Button, __assign({ variant: "contained", color: "primary", disabled: disabled || isValidating, type: "submit", "aria-label": label, onClick: handleClick, ref: buttonRef }, rest, { children: label })));
};
